import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHeartOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.24 2.807c.65-.941 1.433-1.1 1.964-.964.547.14.996.62.996 1.372 0 .554-.396 1.202-1.268 1.952-.71.61-1.587 1.163-2.432 1.68-.845-.517-1.722-1.07-2.432-1.68-.872-.75-1.268-1.398-1.268-1.952 0-.75.449-1.231.996-1.371.531-.136 1.314.022 1.963.963l.741 1.072zm4.76.408C24 1.632 22.985.441 21.65.1c-1.053-.27-2.208.005-3.15.841-.943-.836-2.097-1.11-3.15-.84C14.014.442 13 1.633 13 3.215c0 1.39.946 2.501 1.895 3.317.957.823 2.042 1.477 3.122 2.129l.483.293.483-.293c1.08-.652 2.165-1.306 3.122-2.13C23.055 5.717 24 4.606 24 3.216m-7.13 6.854 1.63.992 1.629-.992c.244-.148.515-.312.801-.492Q21 10.286 21 11c0 2.418-.585 4.837-2.038 6.69l4.034 4.034-1.272 1.272-4.026-4.025C16.142 20.22 13.96 21 11 21 3.5 21 1 16 1 11S3.5 1 11 1q.348 0 .683.014a5.14 5.14 0 0 0-.483 2.201c0 2.227 1.497 3.801 2.522 4.682 1.03.885 2.266 1.636 3.149 2.172"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierFilledHeartOutlinedSize24Glyph.displayName = 'MagnifierFilledHeartOutlinedSize24Glyph';
